"use client"

// THEME COMPLIANCE: All UI implementations must support both dark and light themes.

import * as React from "react"
import { ThemeProvider as NextThemeProvider, ThemeProviderProps } from "next-themes"

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemeProvider
      attribute="class"
      enableSystem
      disableTransitionOnChange
      defaultTheme="dark"
      {...props}
    >
      {children}
    </NextThemeProvider>
  )
}

